<template>
  <PerfectScrollbar style="margin-top: 50px" class="MaxWidthStylesheet">
    <div class="AllShowLogoInputAndLAbel">
      <form>
        <div class="ShowLogoInputAndLAbel">

          <label>{{ $t('editUserPage.firstName') }}</label>

          <div class="ShowAllNavBarStatus">
            <input v-model="Fname" autocomplete="off" type="text" name="name">
          </div>

        </div>

        <div class="ShowLogoInputAndLAbel">
          <label>{{ $t('editUserPage.lastName') }}</label>

          <div class="ShowAllNavBarStatus">
            <input autocomplete="off"  v-model="Lname" type="text" name="username">
          </div>

        </div>

        <div class="ShowLogoInputAndLAbel">
          <label>{{ $t('editUserPage.email') }}</label>
          <div class="ShowAllNavBarStatus">
            <input onkeypress="return /[a-z , 0-9 , '.' , '_' ,'-','@']/i.test(event.key)" for="email" @keyup="ShowButton"  @blur="validateEmail"  v-model="email" type="email" name="email">
          </div>
        </div>

        <div v-if="errorTrue" class="ShowLogoInputAndLAbelCC">
          <span>{{ $t('editUserPage.emailInvalidError') }}</span>
          <div class="CercleShowLogoInputAndLAbel"></div>
        </div>

        <div class="ShowLogoInputAndLAbel">
          <label>{{ $t('editUserPage.mobileNumber') }}</label>
          <div class="ShowAllNavBarStatus">
            <input onkeypress="return /[۰-۹ , 0-9]/i.test(event.key)" minlength="0" maxlength="11" autocomplete="off" @keyup="ShowButton" v-model="number" type="text" name="number">
          </div>
        </div>

        <div v-if="numberTitle === true" class="ShowLogoInputAndLAbelCC">
          <span>{{ $t('editUserPage.mobileNumberLengthError') }}</span>
          <div class="CercleShowLogoInputAndLAbel"></div>
        </div>

        <div class="ShowLogoInputAndLAbel">
          <label>{{ $t('editUserPage.profileImage') }}</label>
          <div class="ShowAllNavBarStatus">
            <input type="file" @change="handleImageUpload" accept="image/*" name="profileImage">
          </div>
          <div v-if="userGet.image" class="current-image-preview">
            <img :src="userGet.image" alt="Current Profile Image" style="width: 50px; height: 50px; border-radius: 50%; margin-top: 10px;">
          </div>
        </div>

        <div @click="DataUpdateUser" class="ShowLogoInputAndLAbel23">
          {{ $t('editUserPage.edit') }}
        </div>
      </form>
    </div>
  </PerfectScrollbar>
</template>

<script>
import { PerfectScrollbar } from 'vue3-perfect-scrollbar';
import axios from "@/axios";
import {toast} from "vue3-toastify";

export default {
  name: "editUser",
  components: {
    PerfectScrollbar
  },
  data(){
    return{
      Fname : '',
      Lname : '',
      email : '',
      number : '',
      profileImage: null,
      numberTitle : false,
      errorMessage : '',
      errorTrue : false,
      userGet : {},
      NumberCheck: '',
      NumberLength: 11,
      NumberCount: false
    }
  },
  watch: {
    email(value){
      this.validateEmail(value);
    }
  },
  methods:{
    validateEmail(email) {
      if (/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email)) {
        this.errorMessage = '';
        this.errorTrue = false;
      } else {
        this.errorMessage = 'ایمیل به درستی وارد نشده';
        this.errorTrue = true;
      }

      if (email === '') {
        this.errorMessage = '';
        this.errorTrue = false;
      }
    },
    ShowButton(){

      if (this.number === ''){
        this.numberTitle = false
        this.NumberCheck = ''
      }

      if (this.number.length !== this.NumberLength){
        if (this.number != ''){
          if (this.number.length < 11){
            this.NumberCheck = false;
            this.NumberLength = 0;
            this.NumberCount = true;
            this.numberTitle = true;
          }else {
            this.NumberCheck = true;
            this.NumberCount = 0;
            this.numberTitle = false;

          }
        }else {
          this.NumberCheck = '';
          this.numberTitle = false;
          this.NumberCount = '';
        }
      }

    },
    handleImageUpload(event) {
      const file = event.target.files[0];
      if (file) {
        // Convert image to base64 for storage
        const reader = new FileReader();
        reader.onload = (e) => {
          this.profileImage = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    },
    async DataUpdateUser(){

      let attempts = 0;
      const maxAttempts = 10;
      const delay = 100;
      while (attempts < maxAttempts) {
        try {
          const updateData = {
            user_id: this.userGet.id,
            firstname: this.Fname,
            lastname: this.Lname,
            email: this.email,
            mobile: this.number,
          };

          if (this.profileImage) {
            updateData.image = this.profileImage;
          }

          const response = await axios.post('/update-user-profile' , updateData);

          if (response.data.success){
            localStorage.setItem('user', JSON.stringify(response.data.user));
            localStorage.setItem('email', this.email);

            toast(this.$t('profile.updateSuccess'), {
              autoClose: 3000,
              position: "top-right",
              type: "success",
            });

            this.$router.go(-1);
          }

          return;
        } catch (error) {
          if (error.response) {
            const errors = error.response.data.errors;
            const keys = Object.keys(errors);
            for (const key of keys) {
              toast(errors[key].join(', '), {
                autoClose: 3000,
                position: "top-right",
                type: "error",
              });
            }
            return;
          }

          if (error.response && error.response.status === 500) {
            console.error('Server error 500: Stopping further attempts.');
            return;
          }

        }

        attempts++;
        await new Promise(resolve => setTimeout(resolve, delay));
      }
    }
  },
  mounted() {
    const userData = localStorage.getItem('user');
    if (userData) {
      this.userGet = JSON.parse(userData);

      // Handle existing users who don't have firstname/lastname split
      if (this.userGet.firstname && this.userGet.lastname) {
        this.Fname = this.userGet.firstname;
        this.Lname = this.userGet.lastname;
      } else if (this.userGet.name) {
        // Split the name if firstname/lastname are not available
        const nameParts = this.userGet.name.trim().split(' ');
        this.Fname = nameParts[0] || '';
        this.Lname = nameParts.slice(1).join(' ') || '';
      } else {
        this.Fname = '';
        this.Lname = '';
      }

      this.email = this.userGet.email || '';
      this.number = this.userGet.mobile || '';
    }
  }
}
</script>

<style scoped>

</style>